import React, { useEffect, useState } from 'react';
import PageContent from '../../components/layout/PageContent';
import axios from 'axios';
import CustomForm from '../../components/form/CustomForm';
import { useHistory } from 'react-router';
import { Input } from 'antd';

const UserEdit = ({
	location: { state: { id = null } = {} } = {},
}) => {

	const [ fields, setFields ] = useState([]);
	const [ loadingFields, setLoadingFields ] = useState(false);
	const [ pw, setPW ] = useState(undefined);

	const history = useHistory();

	useEffect(() => {
		setLoadingFields(true);
		axios.get(`/api/1.0/user/${id}`)
		.then(({ data = {} }) => {
			const { result = {  } } = data;
			setFields(result?.data ?? []);
		})
		.catch(err => {
			console.error('Fetch User: ', err);
		})
		.finally(() => setLoadingFields(false))
	}, [id]);

	const handleSubmit = (fields) => {
		const params = {
			...fields,
		}
		return axios.post(`/api/v1.0/user/${id}`, params)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/user');
			}
		})
		.catch(err => {
			console.error('Update User: ', err);
		})
	}

	const handleCancel = () => {
		history.push('/user')
	};

	const getFields = () => {
		return fields.map(field => {
			if (field.key === 'password') {
				return {
					...field,
					instance: 'custom',
					component: (
						<Input
						type='password'
						onChange={e => {
							if (pw === undefined) {
								setPW(e.currentTarget.value.slice(-1));
							} else {
								setPW(e.currentTarget.value);
							}
						}}
						/>
					),
					value: pw === undefined ? field.value : pw,
					// maskedValue: pw,
				}
			}
			return {
				...field,
			}
		})
	}

	return (
		<PageContent
			background='#ffffff'
			subheader={{
				title: 'Системийн хэрэглэгч засах',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={getFields()}
				loading={loadingFields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
			/>
		</PageContent>
	)
}

export default UserEdit;